/* Shopify line keys can change when discounts recalculate. Match merchandise, properties and selling plan, never variant alone. */
window.TdhqCartLines = (function () {
 function identity(item) {var p=item.properties||{};return JSON.stringify([String(item.variant_id||item.id),String(item.selling_plan_allocation&&item.selling_plan_allocation.selling_plan.id||item.plan||''),Object.keys(p).sort().map(function(k){return [k,String(p[k])];})]);}
 function read(el){var p={};try{p=JSON.parse(el.getAttribute('data-line-properties')||'{}')||{};}catch(e){}return {id:el.getAttribute('data-line-variant'),plan:el.getAttribute('data-line-plan')||'',properties:p};}
 function stamp(el,item){el.setAttribute('data-line-variant',item.variant_id||item.id);el.setAttribute('data-line-plan',item.selling_plan_allocation&&item.selling_plan_allocation.selling_plan.id||item.plan||'');el.setAttribute('data-line-properties',JSON.stringify(item.properties||{}));}
 function rekey(scope,selector,keyAttr,items,targets){var rows=Array.prototype.slice.call(scope.querySelectorAll(selector)),map={};items.forEach(function(item){if(rows.some(function(r){return r.getAttribute(keyAttr)===item.key;}))return;var ident=identity(item);var candidates=rows.filter(function(r){return !items.some(function(n){return n.key===r.getAttribute(keyAttr);})&&identity(read(r))===ident;});if(candidates.length!==1||items.filter(function(n){return identity(n)===ident;}).length!==1)return;var row=candidates[0],old=row.getAttribute(keyAttr);map[old]=item.key;[row].concat(Array.prototype.slice.call(row.querySelectorAll('*'))).forEach(function(el){Array.prototype.slice.call(el.attributes).forEach(function(a){if(a.name.indexOf('data-')===0&&a.value===old)el.setAttribute(a.name,item.key);});});if(targets&&Object.prototype.hasOwnProperty.call(targets,old)){targets[item.key]=targets[old];delete targets[old];}stamp(row,item);});return map;}
 return {identity:identity,read:read,stamp:stamp,rekey:rekey};
})();
/* NATIVE BUNDLES (27 Oct 2026, wf17/bundles-1026/PLAN-1027.md). What is inside each bundle, by the bundle's variant
   id: [[part variant id, units per bundle, name, stock or -1]]. Sources: snippets/tdhq-bundle-map (every bundle in the
   basket: the drawer on load and the tdhq-cart-state section after an add) and snippets/tdhq-bundle-parts (the bundle
   on this page, with the parts' stock). Used for the drawer's "Includes ..." line and by the add guard below. */
window.TdhqBundles = (function () {
  var known = {};
  function put(id, parts) {
    if (!id || !Array.isArray(parts) || !parts.length) return;
    var old = known[String(id)] || [];
    known[String(id)] = parts.map(function (p) {
      var o = old.filter(function (x) { return String(x[0]) === String(p[0]); })[0] || [];
      return [String(p[0]), Number(p[1]) || 1, p[2] || o[2] || '', p[3] !== undefined ? Number(p[3]) : (o[3] !== undefined ? o[3] : -1)];
    });
  }
  function fromMap(text) {
    try { var j = JSON.parse(text); Object.keys(j || {}).forEach(function (k) { put(k, j[k]); }); } catch (e) {}
  }
  function scan(scope) {
    (scope || document).querySelectorAll('template[data-tdhq-bundle-map]').forEach(function (t) { fromMap(t.content.textContent); });
    (scope || document).querySelectorAll('script[data-tdhq-bundle-parts]').forEach(function (s) {
      try {
        var parts = JSON.parse(s.textContent);
        put(s.getAttribute('data-bundle-variant'), parts.map(function (p) { return [p[0], p[1], '', p[2]]; }));
      } catch (e) {}
    });
  }
  return {
    scan: scan,
    fromMap: fromMap,
    parts: function (id) { if (!known[String(id)]) scan(); return known[String(id)] || null; }
  };
})();
/* ONE NOTICE (23 Oct 2026; restyled the same day, owner: the dark panels "look AI made", match our design, with an
   icon). Every add message is a house panel - the Click & Collect panel's shape (32px round icon tile, bold title,
   13px text) in the HQ Rewards bar's yellow for a stock limit, red when something failed, green when added (CSS
   .tdhq-note in tdhq-core.css). TdhqNote.fill() dresses any element that way; TdhqNote.show() puts one over the
   bottom of a product's picture (cards, quick view) and fades it after a few seconds, so nothing moves. The product
   page's side notification (tdhq-pdp.js) is filled by the same builder. role=alert so it is announced. */
(function () {
  'use strict';
  if (window.TdhqNote) return;
  var ERR = /sold out|could not|couldn.t|try again|not available|unavailable|went wrong|error/i;
  var LIMIT = /in your basket|in stock|we have/i;
  /* 27 Oct (owner: a draft bundle answered "Cannot find variant" under the title "Stock limit reached"): only a
     message about stock is a stock limit; anything else Shopify says is an error, in plain words. */
  function kindOf(message, kind) {
    if (kind) { return kind; }
    if (LIMIT.test(message) && !/sold out/i.test(message)) { return 'limit'; }
    return 'error';
  }
  function titleOf(message, kind) {
    if (kind === 'ok') { return 'Added to your basket'; }
    if (kind === 'limit') { return 'Stock limit reached'; }
    if (/sold out/i.test(message)) { return 'Sold out'; }
    return /not on sale/i.test(message) ? 'Not available' : 'Could not add to basket';
  }
  function fill(el, message, kind, title) {
    /* Shopify's own wording, said plainly: "The product 'X - 1L' is already sold out." -> "X - 1L is sold out." */
    message = String(message).replace(/^The product '(.+)' is already sold out\.?$/, '$1 is sold out.')
      .replace(/^Cannot find variant\.?$/i, 'This item is not on sale at the moment.');
    kind = kindOf(message, kind);
    var icon = kind === 'ok' ? 'check' : kind === 'limit' ? 'basket' : 'alert';
    el.setAttribute('data-kind', kind);
    el.innerHTML = '<span class="tdhq-note__icon"><svg class="tdhq-icon tdhq-g--' + icon + '" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"></svg></span>' +
      '<span class="tdhq-note__body"><strong class="tdhq-note__title"></strong><span class="tdhq-note__text"></span></span>';
    el.querySelector('.tdhq-note__title').textContent = title || titleOf(message, kind);
    el.querySelector('.tdhq-note__text').textContent = message;
    return el;
  }
  function hide(box) {
    window.clearTimeout(box._t);
    box.classList.remove('is-open');
    box._t = window.setTimeout(function () { if (box.parentNode && !box.classList.contains('is-open')) { box.remove(); } }, 400);
  }
  window.TdhqNote = {
    fill: fill,
    show: function (host, message, ms, kind) {
      if (!host || !message) { return; }
      var box = null;
      for (var i = 0; i < host.children.length; i++) { if (host.children[i].classList.contains('tdhq-note')) { box = host.children[i]; } }
      if (!box) {
        box = document.createElement('div');
        box.className = 'tdhq-note';
        box.setAttribute('role', 'alert');
        host.appendChild(box);
      }
      fill(box, message, kind);
      box.classList.remove('is-open');
      void box.offsetWidth;
      box.classList.add('is-open');
      window.clearTimeout(box._t);
      box._t = window.setTimeout(function () { hide(box); }, ms || 5000);
    },
    clear: function (host) {
      if (!host) { return; }
      for (var i = 0; i < host.children.length; i++) { if (host.children[i].classList.contains('tdhq-note')) { hide(host.children[i]); } }
    }
  };
})();
/* STUCK BASKET RECOVERY AND STOCK GATE (23 Oct 2026 audit).
   Serialize same-origin adds so each stock check sees the previous add. Shopify can partly fulfil a 422:
   never retry a multi-line request or rebuild a populated basket. Country recovery and a fresh basket are
   allowed only for a single line in a verified empty basket with no notes, attributes or discount codes. */
(function () {
  'use strict';
  if (window.__tdhqAddGuard || !window.fetch) return;
  window.__tdhqAddGuard = true;
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function addURL(input, init) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url || String(input), location.href);
      var method = (init && init.method) || (input && input.method) || 'GET';
      return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add(?:\.js)?$/i.test(url.pathname) &&
        String(method).toUpperCase() === 'POST' ? url : null;
    } catch (e) { return null; }
  }
  function linesFrom(body) {
    try {
      var data;
      if (typeof body === 'string') {
        data = body.trim().charAt(0) === '{' ? JSON.parse(body) : null;
        if (!data) body = new URLSearchParams(body);
      }
      if (!data && body && typeof body.get === 'function') {
        data = { id: body.get('id'), quantity: body.get('quantity') || 1 };
      }
      var lines = data && (Array.isArray(data.items) ? data.items : [data]);
      if (!lines || !lines.length || lines.some(function (l) {
        return !l || !/^\d+$/.test(String(l.id)) || Number(l.id) <= 0 ||
          !/^\d+$/.test(String(l.quantity === undefined ? 1 : l.quantity)) || Number(l.quantity === undefined ? 1 : l.quantity) < 1;
      })) return null;
      return lines.map(function (l) { return { id: String(l.id), quantity: Number(l.quantity === undefined ? 1 : l.quantity) }; });
    } catch (e) { return null; }
  }
  function readCart(root) {
    return nativeFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Basket read failed'); return r.json(); })
      .then(function (cart) { return cart && Array.isArray(cart.items) ? cart : null; }, function () { return null; });
  }
  function bare(cart) {
    return cart && cart.item_count === 0 && cart.items.length === 0 && !cart.note &&
      !Object.keys(cart.attributes || {}).length && !(cart.discount_codes || []).length &&
      !(cart.cart_level_discount_applications || []).length;
  }
  function limits() {
    var map = {};
    /* Build-your-own kits expose live Liquid stock, including zero. Untracked parts have no attribute. */
    document.querySelectorAll('[data-kit-machine-stock]').forEach(function (el) {
      map[el.getAttribute('data-kit-machine')] = Number(el.getAttribute('data-kit-machine-stock'));
    });
    document.querySelectorAll('[data-kit-variant][data-kit-stock]').forEach(function (el) {
      map[el.getAttribute('data-kit-variant')] = Number(el.getAttribute('data-kit-stock'));
    });
    /* Fixed kits include a third value: part stock, or -1 when overselling is allowed. */
    document.querySelectorAll('form[data-tdhq-kit-items]').forEach(function (form) {
      try {
        var parts = JSON.parse(form.getAttribute('data-tdhq-kit-items'));
        if (Array.isArray(parts)) parts.forEach(function (p) {
          if (Array.isArray(p) && p.length > 2 && Number.isFinite(Number(p[2]))) map[String(p[0])] = Number(p[2]);
        });
      } catch (e) {}
    });
    /* A bundle page's parts: the stock of each part, or -1 when the part is not counted. */
    document.querySelectorAll('script[data-tdhq-bundle-parts]').forEach(function (s) {
      try {
        JSON.parse(s.textContent).forEach(function (p) {
          if (Array.isArray(p) && p.length > 2 && Number(p[2]) >= 0) map[String(p[0])] = Number(p[2]);
        });
      } catch (e) {}
    });
    return map;
  }
  function overStock(lines, cart) {
    var Q = window.TdhqQty, B = window.TdhqBundles, live = limits(), wanted = {}, held = {}, inBundle = {};
    /* A bundle uses its parts' stock (27 Oct): a bundle and the same item bought loose share it, so both sides count
       the parts inside every bundle as well as the lines themselves. */
    function count(into, id, qty) {
      into[id] = (into[id] || 0) + qty;
      var parts = B && B.parts(id);
      if (parts) parts.forEach(function (p) { into[p[0]] = (into[p[0]] || 0) + qty * p[1]; inBundle[p[0]] = p[2]; });
    }
    lines.forEach(function (l) { count(wanted, String(l.id), l.quantity); });
    if (cart) cart.items.forEach(function (it) { count(held, String(it.variant_id || it.id), Number(it.quantity || 0)); });
    var ids = Object.keys(wanted);
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i], cap = Object.prototype.hasOwnProperty.call(live, id) ? live[id] : (Q && Q.stock ? Q.stock(id) : null);
      if (cap === null || cap === undefined || cap < 0 || !Number.isFinite(cap)) continue;
      if (!cart) return 'We could not check your basket. Please try again.';
      if (wanted[id] > Math.max(0, cap - (held[id] || 0))) {
        if (inBundle[id] !== undefined) {
          var what = inBundle[id] || 'an item in this bundle';
          return cap === 0 ? what + ' is sold out.' : 'Only ' + cap + ' x ' + what + ' in stock, and your basket already holds ' + (held[id] || 0) + ' (bundles included).';
        }
        return (Q && Q.reason && Q.reason(id, 'add')) || (cap === 0 ? 'This item is sold out.' : 'Only ' + cap + ' in stock. Your basket already holds ' + (held[id] || 0) + '.');
      }
    }
    return '';
  }
  function refuse(message) {
    return new Response(JSON.stringify({ status: 422, message: message, description: message }), { status: 422, headers: JSON_H });
  }
  function soldOut(res) {
    if (!res || res.status !== 422) return Promise.resolve(false);
    return res.clone().json().then(function (j) {
      return /sold out/i.test((j && (j.description || j.message)) || '');
    }, function () { return false; });
  }
  function toUK(root) {
    var fd = new FormData();
    fd.append('form_type', 'localization'); fd.append('utf8', '\u2713');
    fd.append('_method', 'put');
    fd.append('country_code', 'GB'); fd.append('return_to', root + 'cart.js');
    return nativeFetch(root + 'localization', { method: 'POST', body: fd, redirect: 'manual', credentials: 'same-origin' })
      .then(function (r) { return r.ok || r.type === 'opaqueredirect' || (r.status >= 300 && r.status < 400); }, function () { return false; });
  }
  function recover(send, first, lines, before, root, signal) {
    if (!lines || lines.length !== 1 || !bare(before)) return Promise.resolve(first);
    return soldOut(first).then(function (stuck) {
      if (!stuck || (signal && signal.aborted)) return first;
      return readCart(root).then(function (after) {
        if (!bare(after)) return first;
        return toUK(root).then(function (changed) {
          if (!changed || (signal && signal.aborted)) return first;
          /* Recheck after localization too: another tab may have added an item. */
          return readCart(root).then(function (current) {
            if (!bare(current)) return first;
            return send().then(function (second) {
              return soldOut(second).then(function (still) {
                if (!still || (signal && signal.aborted)) return second;
                return nativeFetch(root + 'cart/add.js', { method: 'POST', headers: JSON_H,
                  body: JSON.stringify({items:[{id:Number(lines[0].id),quantity:lines[0].quantity}]}), credentials: 'omit' })
                  .then(function (probe) { return probe.ok; }, function () { return false; })
                  .then(function (available) {
                    if (!available || (signal && signal.aborted)) return second;
                    return readCart(root).then(function (empty) {
                      if (!bare(empty)) return second;
                      /* There are no lines or merchant/customer metadata to migrate or lose. */
                      var past = '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
                      document.cookie = 'cart' + past;
                      document.cookie = 'cart' + past + '; domain=.' + location.hostname.replace(/^www\./, '');
                      return send();
                    });
                  });
              });
            });
          });
        });
      });
    });
  }
  window.fetch = function (input, init) {
    var url = addURL(input, init);
    if (!url) return nativeFetch(input, init);
    var request = typeof Request !== 'undefined' && input instanceof Request ? input.clone() : null;
    var signal = (init && init.signal) || (request && request.signal);
    var root = url.pathname.slice(0, url.pathname.indexOf('/cart/add') + 1);
    var body = init && init.body !== undefined ? Promise.resolve(init.body) : request ? request.clone().text() : Promise.resolve(null);
    function send() { return nativeFetch(request ? request.clone() : input, init); }
    function run() {
      if (signal && signal.aborted) return Promise.reject(new DOMException('The operation was aborted.', 'AbortError'));
      return body.then(function (b) {
        var lines = linesFrom(b);
        if (!lines) return send(); /* Preserve native validation for unsupported/invalid payloads; never retry them. */
        return readCart(root).then(function (cart) {
          if (cart && window.TdhqQty) window.TdhqQty.absorb(cart);
          var why = overStock(lines, cart);
          if (why) return refuse(why);
          if (signal && signal.aborted) throw new DOMException('The operation was aborted.', 'AbortError');
          return send().then(function (res) { return recover(send, res, lines, cart, root, signal); });
        });
      });
    }
    var result = queue.then(run, run);
    queue = result.catch(function () {}); /* One failed/aborted request must not stall subsequent adds. */
    return result;
  };
})();

/* ============================================================
   TDHQ CART DRAWER - assets/tdhq-cart-drawer.js

   Owns the slide-over basket: opening, closing, re-rendering, line
   quantity and removal, the free-delivery meter and the cross-sell rail.

   INTEGRATION NOTE. This script deliberately does NOT intercept
   /cart/add submissions itself. Two other places already do that with
   their own validation, busy states and failure fallbacks:

     - assets/tdhq-quickadd.js  (quick add from a product card)
     - sections/dtc-product-main.liquid  (the PDP buy form)

   A third interceptor would either double-post the line or fight them for
   preventDefault. Instead both of those dispatch `tdhq:cart:added` on
   document after a confirmed add, and this script listens. One owner per
   job: they own adding, this owns showing.
   ============================================================ */
(function () {
  'use strict';

  /* Shopify's JSON endpoints hand back UNSIZED originals (1500-2000px). The CDN
     resizes on a `width` query parameter, so ask for what the box needs. Any
     width already on the URL is replaced rather than duplicated. */
  /* the site's one sized-picture helper (TdhqImg, layout head) */
  function sizedImage(url, w) { return window.TdhqImg.sized(url, w); }

  /* WALLETS FOR THE DEVICE (22 Oct 2026, owner: no Google Pay on an iPhone). Shopify lists the shop's wallets in
     the wallet-configs attribute of its accelerated-checkout element and builds the buttons from that list, so on
     an iPhone or iPad Google Pay - and its loading placeholder - is taken out before the element is put on the
     page. Hiding a built button is not enough: Shopify sizes the row for every wallet it was given. Apple Pay is
     only ever listed where the device has it. Anything unexpected leaves Shopify's markup as it came. */
  var appleDevice = /iPhone|iPad|iPod/.test(navigator.userAgent || '') ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function walletsForDevice(html) {
    if (!appleDevice || !html) { return html; }
    try {
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var host = tpl.content.querySelector('shopify-accelerated-checkout-cart');
      if (!host) { return html; }
      var list = JSON.parse(host.getAttribute('wallet-configs') || '[]');
      var kept = list.filter(function (w) { return !w || w.name !== 'google_pay'; });
      if (!kept.length || kept.length === list.length) { return html; }
      host.setAttribute('wallet-configs', JSON.stringify(kept));
      var cells = tpl.content.querySelectorAll('.wallet-cart-grid--skeleton > li');
      if (cells.length === list.length) {
        for (var wi = list.length - 1; wi >= 0; wi--) {
          if (list[wi] && list[wi].name === 'google_pay') { cells[wi].parentNode.removeChild(cells[wi]); }
        }
      }
      return tpl.innerHTML;
    } catch (e) { return html; }
  }
  /* The basket page ships its wallets inert in a template (sections/dtc-cart.liquid); they go on the page here, and
     again after every re-render of that section (its init() calls TdhqWallets.expand - Codex cartsheet-1022). */
  function expandWallets(scope) {
    var tpls = (scope || document).querySelectorAll('template[data-tdhq-wallets]');
    for (var ti = 0; ti < tpls.length; ti++) {
      var walletTpl = tpls[ti];
      if (!walletTpl.parentNode) { continue; }
      var walletBox = document.createElement('div');
      walletBox.innerHTML = walletsForDevice(walletTpl.innerHTML);
      while (walletBox.firstChild) { walletTpl.parentNode.insertBefore(walletBox.firstChild, walletTpl); }
      walletTpl.parentNode.removeChild(walletTpl);
    }
  }
  window.TdhqWallets = { expand: expandWallets };
  expandWallets(document);

  var root = document.querySelector('[data-tdhq-cart-drawer]');
  if (!root || !('fetch' in window)) { return; }
  /* U.42 (9 Oct): the sheet joins the header section, as the menu and Saved sheets do. The header section is
     its own stacking context (sticky, z-index 900); while the sheet is up it is lifted to the sheet's old
     level (html.tdhq-cd-up, tdhq-header.css) and the phone tab bar - outside the section since 21 Oct - is
     lifted one above it, so the bar and the basket count riding above its edge stay in front. Moved while
     still hidden. */
  var hdrSec = document.querySelector('.tdhq-header-section');
  if (hdrSec && root.parentNode !== hdrSec) { hdrSec.appendChild(root); }
  /* Theme editor only: a header re-render throws the old section away with the sheet inside it. Park the sheet on
     <body> as the old section goes and move it into the new one (21 Oct, Codex tabbar-body-1021). */
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.contains && e.target.contains(root)) { document.body.appendChild(root); }
  });
  document.addEventListener('shopify:section:load', function () {
    var hs = document.querySelector('.tdhq-header-section');
    if (hs && root.parentNode !== hs) { hs.appendChild(root); }
  });

  var panel      = root.querySelector('[data-cd-panel]');
  var itemsEl    = root.querySelector('[data-cd-items]');
  var emptyEl    = root.querySelector('[data-cd-empty]');
  var footEl     = root.querySelector('[data-cd-foot]');
  var countEl    = root.querySelector('[data-cd-count]');
  var subtotalEl = root.querySelector('[data-cd-subtotal]');
  var shipEl     = root.querySelector('[data-cd-ship]');
  var shipMsgEl  = root.querySelector('[data-cd-shipmsg]');
  var shipFillEl = root.querySelector('[data-cd-shipfill]');
  var recsEl     = root.querySelector('[data-cd-recs]');
  var recsListEl = root.querySelector('[data-cd-recslist]');

  var moneyFormat = root.getAttribute('data-cd-money') || '&pound;{{amount}}';
  var lastFocused = null;
  var lastCart = null;
  var recsLoadedFor = null;
  var lastAddedProductId = null;

  /* ---------------------------------------------------------------
     Money. Shopify returns cents; the shop's own money_format string
     decides separators and decimals, so honour it rather than hard-coding
     a pound sign — this theme is a white-label fork and gets reused.
     --------------------------------------------------------------- */
  function formatMoney(cents) {
    var value = (cents || 0) / 100;

    function withDelims(num, thousands, decimal, places) {
      var fixed = num.toFixed(places);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places > 0 && parts[1] ? whole + decimal + parts[1] : whole;
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':                                   return withDelims(value, ',', '.', 2);
        case 'amount_no_decimals':                       return withDelims(value, ',', '.', 0);
        case 'amount_with_comma_separator':              return withDelims(value, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator':  return withDelims(value, '.', ',', 0);
        case 'amount_with_apostrophe_separator':         return withDelims(value, "'", '.', 2);
        case 'amount_with_space_separator':              return withDelims(value, ' ', ',', 2);
        case 'amount_no_decimals_with_space_separator':  return withDelims(value, ' ', ',', 0);
        default:                                         return withDelims(value, ',', '.', 2);
      }
    });
  }

  /* Money format strings legitimately contain entities such as &pound;, and some
     product titles come back HTML-escaped. Everything this script renders is
     assigned with textContent, so the ONLY job here is turning an entity into the
     character it denotes.

     Deliberately not the usual `el.innerHTML = str; return el.value` textarea
     trick. That is safe in itself — textarea content is RCDATA, so no elements
     are constructed and nothing executes — but it puts an innerHTML assignment
     fed by server data into a file people will copy from, and the next person to
     reach for it may not be assigning into a textarea. An explicit table costs
     nothing and cannot be misused. */
  var ENTITIES = {
    amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ',
    pound: '£', euro: '€', yen: '¥', cent: '¢',
    reg: '®', copy: '©', trade: '™',
    hellip: '…', mdash: '—', ndash: '–',
    lsquo: '‘', rsquo: '’', ldquo: '“', rdquo: '”',
    deg: '°', times: '×', minus: '−'
  };

  /* OPTION LABELS - the rules of snippets/tdhq-option-label.liquid, for the
     lines this script draws itself (added items, recommendations). Keep the
     two in step: display only, the posted values are never changed. */
  var SIZE_CODES = {
    xsmall: 'XS', xs: 'XS', extrasmall: 'XS', small: 'S', s: 'S', medium: 'M', m: 'M',
    large: 'L', l: 'L', xlarge: 'XL', xl: 'XL', extralarge: 'XL',
    xxlarge: '2XL', xxl: '2XL', '2xl': '2XL', '2xlarge': '2XL',
    xxxlarge: '3XL', xxxl: '3XL', '3xl': '3XL', '3xlarge': '3XL',
    '4xl': '4XL', '4xlarge': '4XL', xxxxl: '4XL', '5xl': '5XL', '5xlarge': '5XL'
  };
  function optKey(name) {
    var n = String(name || '').trim().toLowerCase().replace(/color/g, 'colour')
      .split(' (ml)').join('').split('(ml)').join('').split(' (clothing)').join('').split(' (mm/inch)').join('').trim();
    if (n === 'sze' || n === 'bottle size' || n === 'bottle' || n === 'volume' || n === 'size (l)' || n === 'bottle size (ml)') { return 'size'; }
    return n;
  }
  function optName(name) {
    var n = optKey(name);
    return n.charAt(0).toUpperCase() + n.slice(1);
  }
  /* Title case word by word; a word with a digit in it ("205L", "0-3") stays
     as typed, the same rule as the Liquid snippet. */
  function titleWords(v) {
    return v.split(' ').map(function (w) {
      return /[0-9]/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }
  function optValue(name, value) {
    var n = optKey(name);
    var v = String(value == null ? '' : value).trim();
    var k = v.toLowerCase().replace(/[ .\-]/g, '');
    var k2 = v.toLowerCase().replace(/ /g, '');
    if (n.indexOf('size') !== -1) {
      if (SIZE_CODES[k]) { return SIZE_CODES[k]; }
      if (/^[0-9]/.test(v) && /ml$/.test(k)) { return v.toLowerCase(); }
      if (/^[0-9]/.test(v)) {
        var lit = k2.match(/^(.*?)(litres|litre|ltr)$/);
        if (lit) { return lit[1] + 'L'; }
      }
      if (v.length > 3 && v === v.toUpperCase() && v !== v.toLowerCase()) { return titleWords(v); }
      return v;
    }
    if (k === 'mattblack') { v = 'Matt Black'; } else if (k === 'mattwhite') { v = 'Matt White'; }
    if ((v.length > 3 && v === v.toUpperCase()) || v === v.toLowerCase() ||
        (n.indexOf('colour') !== -1 && v === v.toUpperCase() && v !== v.toLowerCase())) {
      return titleWords(v);
    }
    return v;
  }
  /* Titles as the server prints them: no en/em dashes (the client's copy
     rule; the same chain as the Liquid title outputs). */
  function cleanTitle(s) {
    /* the site's one naming rule first (snippets/tdhq-name-js) */
    if (window.tdhqName) { s = window.tdhqName(s); }
    return String(s || '').split(' \u2013 ').join(' - ').split(' \u2014 ').join(' - ').split('\u2014').join(' - ').split('\u2013').join('-');
  }

  function optLine(pairs) {
    return (pairs || []).filter(function (o) {
      return o && o.name && o.value != null && !(o.name === 'Title' && /^Default/.test(String(o.value)));
    }).map(function (o) { return optName(o.name) + ': ' + optValue(o.name, o.value); }).join(' \u00B7 ');
  }
  function decodeEntities(str) {
    if (str == null) { return ''; }
    str = String(str);
    if (str.indexOf('&') === -1) { return str; }
    return str.replace(/&(#x?[0-9a-f]+|\w+);/gi, function (whole, body) {
      if (body.charAt(0) === '#') {
        var hex = body.charAt(1) === 'x' || body.charAt(1) === 'X';
        var code = parseInt(hex ? body.slice(2) : body.slice(1), hex ? 16 : 10);
        /* Reject anything outside the Unicode range or in the surrogate block;
           String.fromCodePoint throws on those and a title is not worth an
           exception that empties the whole drawer. */
        if (!isFinite(code) || code < 0 || code > 0x10FFFF || (code >= 0xD800 && code <= 0xDFFF)) {
          return whole;
        }
        return String.fromCodePoint(code);
      }
      var named = ENTITIES[body.toLowerCase()];
      return named === undefined ? whole : named;
    });
  }

  function money(cents) { return decodeEntities(formatMoney(cents)); }

  /* Published for the basket PAGE, which needs the same shop money_format to
     paint figures straight from a /cart/change.js payload. One implementation,
     one set of separator rules, so the drawer and the page can never disagree
     about how a price is written. */
  window.tdhqFormatMoney = money;

  /* THE PAYABLE FIGURE (requirement CART-01). Once the basket page's delivery
     estimator has asked Shopify for rates, every /cart/change.js answer carries
     a total_price that INCLUDES the first delivery rate (measured 2026-09-23:
     goods 540, total_price 935 with Express at 3.95) while /cart.js says 540.
     The drawer painted that figure as the Estimated total, so a quantity change
     after an estimate showed the delivery twice over. The payable figure is
     rebuilt from the parts every answer agrees on: the goods after line
     discounts, less the basket-level discounts. Published for the basket page,
     so both baskets use one rule. */
  function payable(cart) {
    if (!cart) { return 0; }
    var cut = (cart.cart_level_discount_applications || []).reduce(function (a, d) {
      return a + (d.total_allocated_amount || 0);
    }, 0);
    return (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) - cut;
  }
  window.tdhqCartPayable = payable;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* A figure that moved gets the basket page's highlight, a wash behind the
     number (MOT-07): the drawer used to rebuild every line with no sign of
     which number had changed. Restarted if it is already running. */
  function setFigure(el, text) {
    if (!el || el.textContent.trim() === String(text).trim()) { return; }
    el.textContent = text;
    if (!isOpen()) { return; }
    el.classList.remove('is-changed');
    void el.offsetWidth;
    el.classList.add('is-changed');
    window.setTimeout(function () { el.classList.remove('is-changed'); }, 700);
  }

  /* COMPARE-AT PRICES (audit UNI-17). A sale line shows the old price struck
     through over the price in the sale red, as the card and the product page
     do. /cart.js carries no compare-at price, so the drawer learns it the way
     it learns stock ceilings: from Liquid (each server-rendered line states
     its variant's compare-at price), and for a line added later from the
     product's own .js, which does carry it. Kept for the session. */
  var WAS_KEY = 'tdhq:was';
  var wasMap = {};
  var wasAsked = {};
  try { wasMap = JSON.parse(window.sessionStorage.getItem(WAS_KEY) || '{}') || {}; } catch (e) { wasMap = {}; }
  function keepWas() {
    try { window.sessionStorage.setItem(WAS_KEY, JSON.stringify(wasMap)); } catch (e) {}
  }
  function seedWas(scope) {
    var lines = (scope || document).querySelectorAll('[data-cd-item][data-cd-was]');
    for (var i = 0; i < lines.length; i++) {
      var k = (lines[i].getAttribute('data-key') || '').split(':')[0];
      if (k) { wasMap[k] = parseInt(lines[i].getAttribute('data-cd-was'), 10) || 0; }
    }
    keepWas();
  }
  function wasOf(item) {
    var id = String(item.id);
    if (Object.prototype.hasOwnProperty.call(wasMap, id)) { return wasMap[id] || 0; }
    askWas(item.handle);
    return 0;
  }
  function askWas(handle) {
    if (!handle || wasAsked[handle]) { return; }
    wasAsked[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('Express checkout section unavailable'); } return r.json(); })
      .then(function (p) {
        if (!p || !p.variants) { return; }
        p.variants.forEach(function (v) { wasMap[String(v.id)] = v.compare_at_price || 0; });
        keepWas();
        if (lastCart && itemsEl) {
          lastCart.items.forEach(function (item) {
            var li = itemsEl.querySelector('[data-cd-item][data-key="' + esc(item.key) + '"]');
            if (li) { paintWas(li.querySelector('.tdhq-cd__money'), item); }
          });
        }
      })
      .catch(function () {});
  }
  function paintWas(box, item) {
    if (!box) { return; }
    var price = box.querySelector('.tdhq-cd__price');
    var s = box.querySelector('.tdhq-cd__was');
    /* struck: the compare-at price on a sale, or the price before an automatic
       discount (the kit's Buy X get Y), whichever is larger */
    var unit = wasOf(item);
    var wasLine = unit > (item.original_price || item.price || 0) ? unit * item.quantity : 0;
    if ((item.original_line_price || 0) > (item.final_line_price || 0) && item.original_line_price > wasLine) { wasLine = item.original_line_price; }
    if (wasLine > (item.final_line_price || 0)) {
      if (!s) {
        s = document.createElement('s');
        s.className = 'tdhq-cd__was';
        var sr = document.createElement('span');
        sr.className = 'tdhq-visually-hidden';
        sr.textContent = 'Was ';
        s.appendChild(sr);
        var v = document.createElement('span');
        v.setAttribute('data-cd-was-val', '');
        s.appendChild(v);
        box.insertBefore(s, price);
      }
      s.querySelector('[data-cd-was-val]').textContent = money(wasLine);
      if (price) { price.classList.add('tdhq-cd__price--sale'); }
    } else {
      if (s) { s.remove(); }
      if (price) { price.classList.remove('tdhq-cd__price--sale'); }
    }
  }

  /* The last product the shopper looked at, from the recently viewed list the
     product page keeps. Seeds the suggestions when the basket is empty. */
  function recentProductId() {
    try {
      var list = JSON.parse(window.localStorage.getItem('dtc_recent_v1')) || [];
      for (var i = 0; i < list.length; i++) { if (list[i] && list[i].id) { return list[i].id; } }
    } catch (e) {}
    return null;
  }

  /* ---------------------------------------------------------------
     Open / close
     --------------------------------------------------------------- */
  function isOpen() { return root.classList.contains('is-open'); }

  /* The header basket is a real <a href="/cart">, and it stays one: with no
     JavaScript it must still go to the cart page. But WITH this script it does
     not navigate - it opens a modal - and it was announcing itself as a plain
     link to /cart, giving no hint that a dialog was about to appear and no way
     to know whether it was already open.

     The promise is made HERE rather than in the Liquid, because this file is
     what keeps it: markup that claims aria-haspopup="dialog" while the script
     that opens the dialog failed to load is a worse lie than the plain link. */
  function cartLinks() {
    return document.querySelectorAll('[data-tdhq-cart-link]');
  }

  function announceDrawerControl(expanded) {
    var links = cartLinks();
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('aria-haspopup', 'dialog');
      links[i].setAttribute('aria-controls', 'tdhqCartDrawerPanel');
      links[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }
  announceDrawerControl(false);

  /* The basket link lives in the HEADER section. When the theme editor
     re-renders that section the link is a brand new element with none of the
     dialog semantics on it, and this file - which lives in the layout, not the
     section - never notices. One line to re-apply them. */
  document.addEventListener('shopify:section:load', function () {
    announceDrawerControl(isOpen());
  });

  function open() {
    if (isOpen()) { return; }
    lastFocused = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('tdhq-cd-up');
    /* The panel must be laid out in its CLOSED state before `is-open` flips it,
       or the browser has no "from" value and the transform snaps into place
       instead of sliding. Reading offsetHeight forces that layout synchronously,
       which is deterministic - the double requestAnimationFrame this replaced
       was not: rAF does not run in a background tab, and this function has
       already put `tdhq-cd-open` on <html>, so a callback that never arrives
       left the page scroll-locked behind a drawer that never appeared. */
    void root.offsetHeight;
    root.classList.add('is-open');
    document.documentElement.classList.add('tdhq-cd-open');
    document.body.classList.add('tdhq-cd-open');
    var closeBtn = root.querySelector('[data-cd-close]:not(.tdhq-cd__scrim)');
    if (closeBtn && closeBtn.focus) { closeBtn.focus(); }
    announceDrawerControl(true);
    express(lastCart ? lastCart.item_count : Number((countEl && countEl.textContent) || 0));
  }

  /* EXPRESS CHECKOUT (21 Oct 2026): Shop Pay / PayPal / Apple Pay / Google Pay, the block the basket page shows.
     It carries Shopify's wallet set-up and wakes the wallets' scripts, so it is fetched once, through the Section
     Rendering API, the first time the drawer is open with something in it, and then kept. Shopify's buttons read
     the basket when pressed, so later changes need no refetch; an empty basket only hides them. */
  var expressEl = root.querySelector('[data-cd-express]');
  var expressSlot = root.querySelector('[data-cd-express-slot]');
  var expressState = 0; /* 0 can request, 1 asking, 2 shown */
  function express(count) {
    if (!expressEl || !expressSlot) { return; }
    if (!count) { expressEl.hidden = true; return; }
    if (expressState === 2) { expressEl.hidden = false; return; }
    if (expressState !== 0 || !isOpen()) { return; }
    expressState = 1;
    /* the basket route, and no JSON Accept header: '/?sections=' sent as JSON came back without the buttons */
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart?sections=tdhq-express-checkout')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var html = d && d['tdhq-express-checkout'];
        /* A null section can be a render failure even on HTTP 200. Empty markup can also
           reflect a basket emptied while this request was in flight. Retry on the next
           drawer open or basket update; never start an automatic request loop. */
        if (typeof html !== 'string' || html.indexOf('accelerated-checkout') === -1) { expressState = 0; return; }
        expressSlot.innerHTML = walletsForDevice(html);
        expressState = 2;
        expressEl.hidden = !(lastCart ? lastCart.item_count : count);
      })
      .catch(function () { expressState = 0; });
  }

  function close() {
    if (!isOpen()) { return; }
    root.classList.remove('is-open');
    document.documentElement.classList.remove('tdhq-cd-open');
    document.body.classList.remove('tdhq-cd-open');
    /* keep it in the tree until the slide-out finishes, then hide it from
       assistive tech and tab order */
    window.setTimeout(function () {
      if (!isOpen()) { root.hidden = true; document.documentElement.classList.remove('tdhq-cd-up'); }
    }, window.TdhqMotion && window.TdhqMotion.calm() ? 0 : 340);
    if (lastFocused && lastFocused.focus) { lastFocused.focus(); }
    lastFocused = null;
    announceDrawerControl(false);
  }

  /* ---------------------------------------------------------------
     Rendering
     --------------------------------------------------------------- */
  /* Lines Liquid told us cannot be shipped. Seeded from the server-rendered
     drawer on boot and re-applied on every re-render, because /cart.js does not
     report availability and asking per variant would cost a request per line.
     A line added during the session is one the shopper just added successfully,
     so this set never needs to grow on its own. */
  var goneKeys = {};
  Array.prototype.forEach.call(
    (root && root.querySelectorAll('[data-cd-item][data-cd-gone]')) || [],
    function (el) { goneKeys[el.getAttribute('data-key')] = true; }
  );

  function lineNode(item) {
    var li = document.createElement('li');
    li.className = 'tdhq-cd__item';
    li.setAttribute('data-cd-item', '');
    li.setAttribute('data-key', item.key);
    window.TdhqCartLines.stamp(li, item);
    if (goneKeys[item.key]) {
      li.className += ' tdhq-cd__item--gone';
      li.setAttribute('data-cd-gone', '');
    }

    var thumb = document.createElement('a');
    thumb.className = 'tdhq-cd__thumb';
    thumb.href = item.url;
    thumb.tabIndex = -1;
    thumb.setAttribute('aria-hidden', 'true');
    if (item.image) {
      var img = document.createElement('img');
      /* the line's box is 62px on a phone and 74px from 600px: the browser
         takes the file its screen needs (240 covers the phone at 3x) */
      img.sizes = '(max-width: 599px) 62px, 74px';
      img.srcset = sizedImage(item.image, 80) + ' 80w, ' + sizedImage(item.image, 160) + ' 160w, ' + sizedImage(item.image, 240) + ' 240w';
      img.src = sizedImage(item.image, 240);
      img.alt = '';
      img.loading = 'lazy';
      img.setAttribute('data-tdhq-fit', 'thumb');
      thumb.appendChild(img);
    }
    li.appendChild(thumb);

    var info = document.createElement('div');
    info.className = 'tdhq-cd__info';

    var name = document.createElement('a');
    name.className = 'tdhq-cd__name';
    name.href = item.url;
    name.textContent = cleanTitle(decodeEntities(item.product_title || item.title));
    info.appendChild(name);

    /* The options as the product page prints them ("Size: 500ml"), from the
       line's own options_with_values; the raw variant title only if a
       response ever lacks them. */
    var vTitle = optLine(item.options_with_values || []) ||
      ((item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '');

    /* A line on a plan (the monthly Trade Membership) names the plan, as the
       Liquid render and checkout do, and keeps its quantity: one membership
       per account, so it gets the quantity box without - and +. */
    var onPlan = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
    if (onPlan) {
      var sp = document.createElement('p');
      sp.className = 'tdhq-cd__variant';
      sp.textContent = decodeEntities(item.selling_plan_allocation.selling_plan.name || '');
      info.appendChild(sp);
    }

    /* The line's own properties, as snippets/tdhq-line-props prints them (U.50): a gift card's recipient,
       send date and message. Keys starting with "_" are Shopify's own. */
    var props = item.properties || {};
    Object.keys(props).forEach(function (k) {
      var val = props[k] == null ? '' : String(props[k]).trim();
      if (!k || k.charAt(0) === '_' || !val) { return; }
      if (k === 'Send on' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
        var dp = val.split('-');
        val = parseInt(dp[2], 10) + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][parseInt(dp[1], 10) - 1] + ' ' + dp[0];
      }
      var pp = document.createElement('p');
      pp.className = 'tdhq-cd__variant tdhq-lineprop';
      var pk = document.createElement('span');
      pk.className = 'tdhq-lineprop__k';
      pk.textContent = k + ':';
      pp.appendChild(pk);
      pp.appendChild(document.createTextNode(' ' + val));
      info.appendChild(pp);
    });

    /* A native bundle lists what is in it, as snippets/tdhq-bundle-includes prints it (27 Oct). */
    var bparts = window.TdhqBundles && window.TdhqBundles.parts(item.variant_id || item.id);
    if (bparts && bparts.every(function (p) { return p[2]; })) {
      var bp = document.createElement('p');
      bp.className = 'tdhq-cd__variant tdhq-lineprop tdhq-includes';
      var bk = document.createElement('span');
      bk.className = 'tdhq-lineprop__k';
      bk.textContent = root.getAttribute('data-cd-includes') || 'Includes:';
      bp.appendChild(bk);
      bp.appendChild(document.createTextNode(' ' + bparts.map(function (p) { return p[1] + ' × ' + p[2]; }).join(', ')));
      info.appendChild(bp);
    }

    /* Price per litre or kilo, as the Liquid render writes it with
       unit_price_with_measurement: price, "/", the reference amount when it
       is not 1, the unit ("£2.19/100ml", "£21.90/L"). */
    var um = item.unit_price_measurement;
    if (um && item.unit_price != null && um.reference_unit) {
      var up = document.createElement('p');
      up.className = 'tdhq-cd__unit';
      var upSr = document.createElement('span');
      upSr.className = 'tdhq-visually-hidden';
      upSr.textContent = 'Unit price ';
      up.appendChild(upSr);
      var unitName = um.reference_unit === 'l' ? 'L' : um.reference_unit;
      up.appendChild(document.createTextNode(money(item.unit_price) + '/' + (um.reference_value && um.reference_value !== 1 ? um.reference_value : '') + unitName));
      info.appendChild(up);
    }

    var row = document.createElement('div');
    row.className = 'tdhq-cd__row';

    /* Carry the ceiling onto the rebuilt row. The server's <li> states it,
       and this row replaces that <li> - without this the attribute exists only
       until the first render and the line becomes unjudgeable. */
    if (window.TdhqQty) {
      var lineCap = window.TdhqQty.stock(String(item.id));
      li.setAttribute('data-cd-max', lineCap === null ? '0' : String(lineCap));
    }

    var qty = document.createElement('div');
    qty.className = 'tdhq-cd__qty' + (onPlan ? ' tdhq-cd__qty--plan' : '');
    qty.setAttribute('data-cd-qty', '');
    if (!onPlan) { qty.appendChild(stepBtn('-1', 'Decrease quantity of ' + cleanTitle(decodeEntities(item.product_title || item.title)))); }
    var val = document.createElement('span');
    val.className = 'tdhq-cd__qtyval';
    val.setAttribute('data-cd-qtyval', '');
    val.textContent = item.quantity;
    qty.appendChild(val);
    if (!onPlan) { qty.appendChild(stepBtn('1', 'Increase quantity of ' + cleanTitle(decodeEntities(item.product_title || item.title)))); }
    row.appendChild(qty);

    var box = document.createElement('span');
    box.className = 'tdhq-cd__money';
    var price = document.createElement('span');
    price.className = 'tdhq-cd__price';
    price.textContent = money(item.final_line_price);
    box.appendChild(price);
    paintWas(box, item);
    if (vTitle) {
      var v = document.createElement('span');
      v.className = 'tdhq-cd__option';
      v.textContent = decodeEntities(vTitle);
      box.appendChild(v);
    }
    row.appendChild(box);
    info.appendChild(row);

    if (goneKeys[item.key]) {
      var goneNote = document.createElement('p');
      goneNote.className = 'tdhq-cd__gone';
      goneNote.setAttribute('role', 'status');
      goneNote.textContent = 'Out of stock. Remove to continue';
      info.appendChild(goneNote);
    }

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'tdhq-cd__remove';
    rm.setAttribute('data-cd-remove', '');
    rm.setAttribute('aria-label', 'Remove ' + cleanTitle(decodeEntities(item.product_title || item.title)) + ' from basket');
    rm.textContent = 'Remove';
    info.appendChild(rm);

    li.appendChild(info);
    /* The ceiling is known by now (seeded above from the server's lines or
       from a product page earlier in the session), so the "+" and the stock
       note are drawn in their correct state rather than going dead on the
       first press. Here, once the line is complete, and NOT on a timer: a
       timer let the rebuilt list paint one frame without the note, so every
       line under a line at its ceiling jumped 33px up and back down when
       another line was removed (measured at 390). */
    paintLineCap(li);
    return li;
  }

  /* The +/- glyphs are inline SVG in the server-rendered markup; rebuilding
     them here would duplicate the icon set in JS. A character is indistinguishable
     at 14px and the accessible name lives on the button's aria-label. */
  function stepBtn(delta, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tdhq-cd__step';
    b.setAttribute('data-cd-step', delta);
    b.setAttribute('aria-label', label);
    b.textContent = delta === '1' ? '+' : '−';
    return b;
  }

  function render(cart) {
    if (!cart) { return; }

    /* The line list is rebuilt from scratch on every change, so whatever the
       shopper had focused is destroyed - a keyboard or screen-reader user was
       thrown to the top of the document on every single + or -. Remember the
       control by its line key and role, and put focus back on the equivalent
       control in the new markup. */
    var wasFocused = null;
    var active = document.activeElement;
    if (active && root.contains(active)) {
      var owner = active.closest('[data-cd-item]');
      if (owner) {
        wasFocused = {
          key: owner.getAttribute('data-key'),
          step: active.getAttribute('data-cd-step'),
          remove: active.hasAttribute('data-cd-remove')
        };
      }
    }

    var changedKeys = window.TdhqCartLines.rekey(root, '[data-cd-item]', 'data-key', cart.items, cdTargets);
    Object.keys(changedKeys).forEach(function(k){if(goneKeys[k]){goneKeys[changedKeys[k]]=true;delete goneKeys[k];}});
    if(wasFocused && changedKeys[wasFocused.key])wasFocused.key=changedKeys[wasFocused.key];
    lastCart = cart;
    var due = payable(cart);
    if (countEl) { countEl.textContent = cart.item_count; }
    setFigure(subtotalEl, money(due));

    /* Saving row, printed hidden by Liquid in the footer and shown here the
       moment a saving appears (audit cart-07). */
    var savingEl = root.querySelector('[data-cd-saving]');
    var saved = (cart.original_total_price || due) - due;
    if (savingEl) {
      if (saved > 0) { savingEl.textContent = 'You save ' + money(saved); savingEl.hidden = false; }
      else { savingEl.hidden = true; }
    }

    var empty = cart.item_count === 0;
    express(cart.item_count);
    if (emptyEl) {
      var emptyWas = emptyEl.hidden;
      emptyEl.hidden = !empty;
      /* the empty-basket message arrives the way content does (APPEAR values), after the last line has closed */
      if (emptyWas && empty && isOpen() && window.TdhqMotion) { window.TdhqMotion.rise(emptyEl, 0); }
    }
    if (itemsEl) { itemsEl.hidden = empty; }
    if (footEl) { footEl.hidden = empty; }
    if (shipEl) { shipEl.hidden = empty; }

    /* SAME LINES, UPDATED IN PLACE (audit cart-10, MOT-07). Every change used
       to empty the list and rebuild every line, image and button from /cart.js:
       the line the shopper was pressing was replaced mid-gesture, it snapped
       from its busy dim straight back to full, and nothing said which figure
       had moved. When the basket holds the same lines in the same order, only
       the digits and prices are written, the moved price is highlighted, and
       the line fades back up. A different set of lines is rebuilt as before. */
    if (itemsEl) {
      var have = Array.prototype.filter.call(itemsEl.children, function (li) { return li.hasAttribute('data-cd-item'); });
      var same = have.length === cart.items.length && cart.items.every(function (item, i) {
        return have[i].getAttribute('data-key') === item.key;
      });
      if (same) {
        cart.items.forEach(function (item, i) { updateLine(have[i], item); });
      } else {
        /* A DIFFERENT SET OF LINES (21 Oct, owner: an add "just appears" while a removal closes). Lines still in
           the basket are updated in place - rebuilding them re-loaded every picture and the whole list blinked on
           each add. A new line is built and opens in; a line no longer in the basket closes where it is. All of it
           through TdhqMotion, the site's one motion system, and only while the drawer is open. */
        var M = window.TdhqMotion, moving = !!M && isOpen();
        var byKey = {}, wanted = {};
        have.forEach(function (li) { byKey[li.getAttribute('data-key')] = li; });
        cart.items.forEach(function (item) { wanted[item.key] = true; });
        have.forEach(function (li) {
          if (wanted[li.getAttribute('data-key')]) { return; }
          li.removeAttribute('data-cd-item');
          if (moving) { M.exit(li, function () { li.remove(); }); } else { li.remove(); }
        });
        var prev = null;
        cart.items.forEach(function (item) {
          var li = byKey[item.key], fresh = !li;
          if (fresh) {
            li = lineNode(item);
            /* A line with a newer tap still on its way keeps the number the
               shopper asked for, and stays dimmed until that tap settles. */
            if (cdTargets[item.key] !== undefined) {
              var qv = li.querySelector('[data-cd-qtyval]');
              /* a pending removal keeps the basket's number, as queueLine does */
              if (qv && cdTargets[item.key] > 0) { qv.textContent = cdTargets[item.key]; paintLineCap(li); }
              li.classList.add('is-busy');
            }
          } else {
            updateLine(li, item);
          }
          var at = prev ? prev.nextSibling : itemsEl.firstChild;
          if (li !== at) { itemsEl.insertBefore(li, at); }
          prev = li;
          if (fresh && moving) { M.enter(li); }
        });
      }
    }

    renderShip(cart);
    renderPartner(cart);
    syncHeader(cart);

    /* An empty basket offers products too (audit cart-23): the rail is seeded
       from the last product the shopper viewed, and hides only when there is
       none. The heading reads "You may also like" here, not "need". */
    var recsTitle = recsEl && recsEl.querySelector('.tdhq-cd__recstitle');
    if (recsTitle) { recsTitle.textContent = empty ? 'You may also like' : 'You may also need'; }
    if (recsEl) { recsEl.setAttribute('aria-label', empty ? 'You may also like' : 'You may also need'); }
    if (empty) {
      var seen = recentProductId();
      if (seen) { loadRecs(seen); }
      else {
        if (recsEl) { recsEl.hidden = true; }
        recsLoadedFor = null;
      }
    } else {
      /* Seeded from the product the shopper just added, not from whatever
         happens to sit first in the basket - `cart.items[0]` is the OLDEST line,
         so the rail recommended things to go with something added days ago.
         The add sites pass the product id in the event detail; the newest line
         is the fallback when they cannot. */
      var seedId = lastAddedProductId ||
        (cart.items.length ? cart.items[cart.items.length - 1].product_id : null);
      var seedHandle = null;
      for (var si = cart.items.length - 1; si >= 0; si--) {
        if (cart.items[si].product_id === seedId) { seedHandle = cart.items[si].handle; break; }
      }
      loadRecs(seedId, seedHandle);
    }

    if (wasFocused && wasFocused.key) {
      var line = root.querySelector('[data-cd-item][data-key="' + (window.CSS && CSS.escape ? CSS.escape(wasFocused.key) : wasFocused.key) + '"]');
      var target = null;
      if (line) {
        target = wasFocused.remove
          ? line.querySelector('[data-cd-remove]')
          : line.querySelector('[data-cd-step="' + wasFocused.step + '"]');
      }
      /* The line may be gone (quantity taken to zero). Fall back to the panel
         itself rather than letting focus fall out of the drawer entirely. */
      if (!target) { target = root.querySelector('[data-cd-close]:not(.tdhq-cd__scrim)'); }
      if (target && target.focus) { target.focus({ preventScroll: true }); }
    }
  }

  function updateLine(li, item) {
    var pending = cdTargets[item.key] !== undefined;
    var valEl = li.querySelector('[data-cd-qtyval]');
    if (valEl && !pending) { valEl.textContent = item.quantity; }
    setFigure(li.querySelector('.tdhq-cd__price'), money(item.final_line_price));
    paintWas(li.querySelector('.tdhq-cd__money'), item);
    if (window.TdhqQty) {
      var lineCap = window.TdhqQty.stock(String(item.id));
      li.setAttribute('data-cd-max', lineCap === null ? '0' : String(lineCap));
    }
    /* The request succeeded, so whatever the line was last told off for no
       longer applies (a refused change re-writes its message after this). */
    var err = li.querySelector('.tdhq-cd__lineerr');
    if (err) { err.remove(); }
    if (!pending) {
      li.classList.remove('is-busy');
      li.removeAttribute('aria-busy');
    }
    paintLineCap(li);
  }

  function renderShip(cart) {
    if (!shipEl || !shipMsgEl || !shipFillEl) { return; }
    var threshold = parseInt(shipEl.getAttribute('data-cd-threshold'), 10);
    if (!threshold || threshold <= 0) { shipEl.hidden = true; return; }

    /* U.50: Shopify does not count its own gift card products towards a price-based free delivery rate,
       and a digital card is never posted. The meter measures the rest of the basket, and says nothing at
       all when nothing in the basket needs posting. */
    var cdItems = (cart && cart.items) || [];
    var noPost = cdItems.length > 0 && !cdItems.some(function (i) { return i.requires_shipping; });
    if (noPost) { shipEl.hidden = true; shipEl.setAttribute('data-cd-nopost', '1'); return; }
    if (shipEl.hasAttribute('data-cd-nopost')) { shipEl.hidden = false; shipEl.removeAttribute('data-cd-nopost'); }
    var gcLines = cdItems.reduce(function (a, i) { return a + (i.gift_card ? (i.final_line_price || 0) : 0); }, 0);
    var total = payable(cart) - gcLines;
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));

    shipFillEl.style.width = pct + '%';
    shipMsgEl.textContent = '';

    if (remaining <= 0) {
      /* the moment the basket crosses the line, once (not on the first paint) */
      if (!shipEl.classList.contains('is-met') && shipEl.getAttribute('data-cd-painted') === '1' &&
          !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        shipEl.classList.add('is-just-met');
        window.setTimeout(function () { shipEl.classList.remove('is-just-met'); }, 900);
      }
      shipEl.classList.add('is-met');
      var met = document.createElement('strong');
      met.textContent = 'You get free Royal Mail Tracked 24 delivery.';
      shipMsgEl.appendChild(met);
    } else {
      shipEl.classList.remove('is-met');
      shipMsgEl.appendChild(document.createTextNode('Spend '));
      var amt = document.createElement('strong');
      amt.textContent = money(remaining);
      shipMsgEl.appendChild(amt);
      shipMsgEl.appendChild(document.createTextNode(' more for free Tracked 24 delivery.'));
    }
    shipEl.setAttribute('data-cd-painted', '1');
  }

  /* PARTNER BRAND NOTE. /cart.js carries no tags, so a line's Shopify Collective tag is read once from the product's
     own .js (tags included) and remembered for the session; Liquid seeds the first paint. */
  var partnerTag = {};
  var partnerCart = null;
  function renderPartner(cart) {
    var el = root.querySelector('[data-cd-partner]');
    if (!el || !cart) { return; }
    partnerCart = cart;
    var handles = (cart.items || []).map(function (it) { return it.handle; });
    el.hidden = !handles.some(function (h) { return partnerTag[h] === true; });
    handles.forEach(function (h) {
      if (h in partnerTag) { return; }
      partnerTag[h] = null;
      fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          partnerTag[h] = !!(p && (p.tags || []).indexOf('Shopify Collective') > -1);
          if (partnerTag[h] && partnerCart) { renderPartner(partnerCart); }
        })
        .catch(function () { partnerTag[h] = false; });
    });
  }

  /* The header badge is server-rendered on load; after an Ajax change it is the
     only part of the page outside the drawer that is now stale. */
  function syncHeader(cart) {
    document.querySelectorAll('[data-tdhq-cart-count]').forEach(function (el) {
      var sr = el.querySelector('.tdhq-visually-hidden, .visually-hidden');
      el.textContent = cart.item_count;
      if (sr) {
        sr.textContent = cart.item_count === 1 ? 'item in basket' : 'items in basket';
        el.appendChild(sr);
      }
      el.classList.toggle('tdhq-hidden', cart.item_count === 0);
    });
    document.querySelectorAll('[data-tdhq-cart-total]').forEach(function (el) {
      el.textContent = money(payable(cart));
    });
  }

  /* ---------------------------------------------------------------
     Cross-sell. Shopify's own recommendation endpoint, so it stays
     relevant without anyone maintaining a list.
     --------------------------------------------------------------- */
  function loadRecs(productId, handle) {
    if (!recsEl || !recsListEl || !productId) { return; }
    if (recsLoadedFor === productId) { return; }
    recsLoadedFor = productId;

    /* `complementary` is the better rail - it is the merchant's own "goes with
       this" list - but it only returns anything once complementary products
       have been set up in Shopify's Search & Discovery app, and on this store
       nothing has been: the endpoint answers 200 with an empty list for every
       product, so the rail was always hidden and the drawer never offered
       anything. `related` is Shopify's automatic fallback and does return
       products, so it is used whenever complementary comes back empty. That
       ordering means the rail improves by itself the moment the merchant
       configures complementary products - no code change needed. */
    function ask(intent) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=' + intent, {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { return data && Array.isArray(data.products) ? data.products : []; })
        .catch(function () { return []; });
    }

    function paint(products) {
      /* A later basket change owns the rail; an older response must not replace it. */
      if (recsLoadedFor !== productId) { return; }
      recsListEl.textContent = '';
      products.forEach(function (p) {
        /* This rail adds one variant without a selling plan. Subscription-only
           products (including Trade Membership) must use their own enrolment flow. */
        if (!p || !p.available || p.requires_selling_plan || recsListEl.children.length >= 3) { return; }
        if (!(p.variants || []).some(function (v) { return v.available && !v.requires_selling_plan && Number(v.price) > 0; })) { return; }
        /* a battery kit built from its parts is added from its own page, as its parts */
        var tg = p.tags || [];
        if (typeof tg === 'string') { tg = tg.split(/,\s*/); }
        if (tg.indexOf('kit-from-parts') > -1) { return; }
        /* never offer what is already in the basket */
        if (lastCart && lastCart.items.some(function (it) { return it.product_id === p.id; })) { return; }
        recsListEl.appendChild(recNode(p));
      });
      recsEl.hidden = recsListEl.children.length === 0;
      /* suggestions arrive like any other list content */
      if (!recsEl.hidden && isOpen() && window.TdhqMotion) { window.TdhqMotion.reveal(recsListEl.children); }
    }

    /* An empty complementary answer is remembered for the session: the next
       time this product is the newest line, related is asked straight away. */
    function shopify() {
      var none = false;
      try { none = !!window.sessionStorage.getItem('tdhq:comp0:' + productId); } catch (e) { none = false; }
      if (none) { ask('related').then(paint); return; }
      ask('complementary').then(function (products) {
        if (products.length) { paint(products); return; }
        try { window.sessionStorage.setItem('tdhq:comp0:' + productId, '1'); } catch (e) { /* private mode */ }
        ask('related').then(paint);
      });
    }

    /* FIRST the product page's own picks (27 Oct 2026): curated pairings and the upsell rules, from
       /products/<handle>?view=addons (templates/product.addons.liquid). Shopify's automatic related list
       offered air fresheners beside a wash bundle; it is only the fallback now, for a product with no picks.
       The empty basket keeps Shopify's list ("You may also like", seeded from a product viewed, no handle). */
    if (!handle) { shopify(); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    /* no JSON Accept header: with one, Shopify answers with the product's own JSON and ignores the view */
    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=addons', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) { var list = null; try { list = JSON.parse(txt); } catch (e) { list = null; } return Array.isArray(list) ? list : []; })
      .catch(function () { return []; })
      .then(function (picks) { if (picks.length) { paint(picks); } else { shopify(); } });
  }

  function recNode(p) {
    var li = document.createElement('li');
    li.className = 'tdhq-cd__rec';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'tdhq-cd__recimg';
    if (p.featured_image) {
      var im = document.createElement('img');
      /* 52px tile, sized for the screen's density. The recommendations
         endpoint returns the 2000px original, which cost ~40 KB a tile. */
      im.sizes = '52px';
      im.srcset = sizedImage(p.featured_image, 54) + ' 54w, ' + sizedImage(p.featured_image, 108) + ' 108w, ' + sizedImage(p.featured_image, 162) + ' 162w';
      im.src = sizedImage(p.featured_image, 162);
      im.width = 162; im.height = 162;
      im.alt = '';
      im.loading = 'lazy';
      im.setAttribute('data-tdhq-fit', 'thumb');
      imgWrap.appendChild(im);
    }
    li.appendChild(imgWrap);

    var mid = document.createElement('div');
    var a = document.createElement('a');
    a.className = 'tdhq-cd__recname';
    a.href = p.url;
    a.textContent = cleanTitle(decodeEntities(p.title));
    mid.appendChild(a);
    /* first available variant: these cards have no variant picker, and adding an
       unavailable variant would fail at the API for no visible reason */
    var variant = null;
    for (var i = 0; i < (p.variants || []).length; i++) {
      if (p.variants[i].available && !p.variants[i].requires_selling_plan && Number(p.variants[i].price) > 0) { variant = p.variants[i]; break; }
    }
    var variantId = variant ? variant.id : null;

    var pr = document.createElement('span');
    pr.className = 'tdhq-cd__recprice';
    /* `p.price` is the PRODUCT minimum across all variants, but the button adds
       the first AVAILABLE variant - which is often not the cheapest one, because
       the cheapest is frequently the one that sold out. So the card advertised
       one price and the basket jumped by another. Price the card from the
       variant it is actually going to add. */
    pr.textContent = money(variant ? variant.price : p.price);
    mid.appendChild(pr);

    /* Say WHICH variant, when there is more than one to choose between. */
    if (variant && (p.variants || []).length > 1 && variant.title && variant.title !== 'Default Title') {
      var vt = document.createElement('span');
      vt.className = 'tdhq-cd__recvariant';
      var recPairs = (p.options || []).map(function (o, i) {
        return { name: typeof o === 'string' ? o : (o && o.name), value: (variant.options || [])[i] };
      });
      vt.textContent = decodeEntities(optLine(recPairs) || variant.title);
      mid.appendChild(vt);
    }
    li.appendChild(mid);

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'tdhq-cd__recadd';
    add.textContent = 'Add';
    add.setAttribute('aria-label', 'Add to basket, ' + cleanTitle(decodeEntities(p.title)));
    var error = document.createElement('p');
    error.className = 'tdhq-cd__recerror';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    if (!variantId) { add.disabled = true; }
    add.addEventListener('click', function () {
      if (!variantId || add.disabled) { return; }
      add.disabled = true;
      error.hidden = true;
      error.textContent = '';
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: 'tdhq-cart-state', sections_url: window.location.pathname })
      })
        .then(function (r) {
          /* Shopify explains its own refusals - "All 3 … are in your cart" -
             and that sentence is the only thing that tells the shopper why
             the button did nothing. Throwing the body away left the button
             silently re-enabled, which reads as broken. */
          if (!r.ok) {
            return r.json()
              .catch(function () { throw new Error('Could not add this item. Please try again.'); })
              .then(function (e) { throw new Error(e.description || e.message || 'Could not add this item.'); });
          }
          return r.json();
        })
        .then(function (added) { recsLoadedFor = null; return showAdded(added); })
        .catch(function (err) {
          add.disabled = false;
          error.textContent = (err && err.message) || 'Could not add this item. Please try again.';
          error.hidden = false;
        });
    });
    li.appendChild(add);
    li.appendChild(error);
    return li;
  }

  /* ---------------------------------------------------------------
     Mutations
     --------------------------------------------------------------- */
  function refresh() {
    /* the site's one basket read (TdhqCart, layout head): no HTTP cache, retried on a refusal */
    return window.TdhqCart.get()
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { return null; });
  }

  /* The basket as the add itself answered it: the line(s) Shopify returned from /cart/add.js, merged into the last
     basket drawn. Used only when the basket cannot be read after an add, so the drawer and the header count never
     stay one add behind (owner 21 Oct). */
  function fromAdd(added, base) {
    base = base || lastCart;
    if (!base || !added) { return null; }
    var lines = added.items || [added];
    if (!lines.length || !lines[0].key) { return null; }
    var cart = JSON.parse(JSON.stringify(base));
    lines.forEach(function (line) {
      var at = -1;
      cart.items.forEach(function (it, i) { if (it.key === line.key) { at = i; } });
      if (at > -1) { cart.items[at] = line; } else { cart.items.unshift(line); }
    });
    var sum = function (f) { return cart.items.reduce(function (a, it) { return a + (it[f] || 0); }, 0); };
    cart.item_count = sum('quantity');
    cart.items_subtotal_price = sum('final_line_price');
    cart.total_price = cart.items_subtotal_price;
    cart.original_total_price = sum('original_line_price');
    return cart;
  }

  /* Does this basket hold what /cart/add.js just answered? Every added line, at least at that quantity. */
  function holds(cart, added) {
    if (!cart || !added) { return !!cart; }
    var lines = added.items || [added];
    return lines.every(function (line) {
      return !line.key || cart.items.some(function (it) { return it.key === line.key && it.quantity >= (line.quantity || 1); });
    });
  }

  /* AFTER AN ADD (21 Oct): draw the basket only once it is known to hold the add. A read that does not hold it is
     drawn with the add merged in straight away, then read again after 0.3 / 0.8 / 1.6 s until the real basket
     holds it; a read that fails entirely leaves the merged basket and reads once more after 5 s. */
  function bundledCart(added) {
    var html = added && added.sections && added.sections['tdhq-cart-state'];
    if (typeof html !== 'string') { return null; }
    try {
      var node = new DOMParser().parseFromString(html, 'text/html').querySelector('template[data-tdhq-cart-state]');
      if (!node) { return null; }
      var cart = JSON.parse(node.content.textContent);
      var bmap = node.ownerDocument.querySelector('template[data-tdhq-bundle-map]');
      if (bmap && window.TdhqBundles) { window.TdhqBundles.fromMap(bmap.content.textContent); }
      if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0 ||
          !Number.isFinite(cart.total_price) || cart.total_price < 0 || !Number.isFinite(cart.items_subtotal_price) ||
          !cart.items.every(function (line) { return typeof line.key === 'string' && Number.isInteger(line.quantity) && line.quantity > 0 && Number.isFinite(line.final_line_price); }) ||
          cart.items.reduce(function (n, line) { return n + line.quantity; }, 0) !== cart.item_count || !holds(cart, added)) { return null; }
      return cart;
    } catch (err) { return null; }
  }

  function showAdded(added) {
    var confirmed = bundledCart(added);
    if (confirmed) {
      render(confirmed);
      publishCartChange(confirmed);
      return Promise.resolve(confirmed);
    }
    var waits = [300, 800, 1600];
    function attempt(n) {
      return window.TdhqCart.get().then(function (cart) {
        if (holds(cart, added)) { render(cart); publishCartChange(cart); return cart; }
        var merged = fromAdd(added, cart);
        if (merged) { render(merged); }
        if (n >= waits.length) { if (merged) { publishCartChange(merged); } return merged || cart; }
        return new Promise(function (ok) { window.setTimeout(ok, waits[n]); }).then(function () { return attempt(n + 1); });
      }, function () {
        var merged = fromAdd(added);
        if (merged) { render(merged); publishCartChange(merged); }
        window.setTimeout(function () { refresh().then(function (c) { if (c) { publishCartChange(c); } }); }, 5000);
        return merged;
      });
    }
    return attempt(0);
  }

  /* A message beside the control the shopper just used, the same shape the
     basket page uses. Shopify answers an over-quantity request with 422 and a
     plain-English description ("You can only add 3 of this item to your cart"),
     which is exactly what the shopper needs to see. */
  /* One place selectors escape a cart line key, which contains a colon. */
  function esc(key) { return (window.CSS && CSS.escape) ? CSS.escape(key) : key; }

  /* THE BASKET PAGE IS ALSO A BASKET. On /cart the header link opens this
     drawer instead of navigating, and the page underneath keeps its rendered
     quantities in `updates[]` - so its Checkout re-posted them and undid
     whatever was done in here. Saying what happened lets that page re-render
     itself; everywhere else nothing is listening and this costs one event. */
  /* Everything Liquid rendered into this drawer, handed to the shared store
     so the "+" can be judged after the drawer has redrawn itself from
     /cart.js - which carries no stock. Runs again after each server render. */
  function seedCeilings(scope) {
    if (!window.TdhqQty) { return; }
    var lines = (scope || document).querySelectorAll('[data-cd-item][data-cd-max]');
    for (var i = 0; i < lines.length; i++) {
      var k = lines[i].getAttribute('data-key') || '';
      if (k) { window.TdhqQty.remember(k.split(':')[0], lines[i].getAttribute('data-cd-max')); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { seedCeilings(root); });
  } else { seedCeilings(root); }
  seedWas(root);

  function publishCartChange(cart) {
    document.dispatchEvent(new CustomEvent('tdhq:cart:changed', { detail: { cart: cart || null } }));
  }

  function showLineError(lineEl, msg) {
    if (!lineEl || !msg) { return; }
    var box = lineEl.querySelector('.tdhq-cd__lineerr');
    if (!box) {
      box = document.createElement('p');
      box.className = 'tdhq-cd__lineerr';
      box.setAttribute('role', 'alert');
      lineEl.appendChild(box);
    }
    box.textContent = msg;
    if (window.TdhqMotion) { window.TdhqMotion.show(box); }
  }

  /* Say what just happened. Blanking first and setting on the next frame is
     what makes a REPEATED string fire: pressing "+" three times writes the same
     shape of sentence each time, and a live region whose text is assigned the
     identical value announces nothing. Same trick as tdhq-quickadd.js. */
  function announce(message) {
    var live = root.querySelector('[data-cd-live]');
    if (!live || !message) { return; }
    live.textContent = '';
    /* A TIMER, not requestAnimationFrame. rAF is paused while the tab is in the
       background, so an announcement scheduled that way can simply never
       arrive. A timer is throttled there, not cancelled. */
    window.setTimeout(function () { live.textContent = message; }, 30);
  }

  /* ONE REQUEST IN FLIGHT, EVERY TAP REMEMBERED.

     The cart API is not transactional, so two concurrent /cart/change.js posts
     can race and lose an update - but a tap must never be dropped either. Each
     line keeps the quantity it was last asked for; taps update that target (and
     the digit) immediately, and when the in-flight request settles the newest
     target goes if it still differs from what was sent. Same shape as the
     basket page. */
  var cdTargets = {};
  var cdBusy = false;

  /* The "+" goes dead at the stock ceiling, the way every other stepper on
     the site does. Called wherever a line's digit is written. */
  function paintLineCap(lineEl) {
    if (!lineEl || !window.TdhqQty) { return; }
    var key = lineEl.getAttribute('data-key') || '';
    var cap = window.TdhqQty.stock(key.split(':')[0]);
    var plus = null;
    var btns = lineEl.querySelectorAll('[data-cd-step]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-cd-step') === '1') { plus = btns[i]; break; }
    }
    if (!plus) { return; }
    var valEl = lineEl.querySelector('[data-cd-qtyval]');
    var now = parseInt(valEl && valEl.textContent, 10) || 0;
    var atCap = cap !== null && now >= cap;
    plus.disabled = atCap;

    /* Say why, in the same words and the same quiet style the product page
       uses. Not the line-error box: nothing has gone wrong, there is simply
       no more stock. */
    var note = lineEl.querySelector('[data-qty-note]');
    if (!atCap) {
      if (note) { note.textContent = ''; note.hidden = true; }
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'tdhq-qtynote';
      note.setAttribute('data-qty-note', '');
      note.setAttribute('role', 'status');
      /* beside Remove, on its row (client: "close to remove button to save space") */
      var rmBtn = lineEl.querySelector('.tdhq-cd__remove');
      if (rmBtn && rmBtn.parentNode) { rmBtn.parentNode.insertBefore(note, rmBtn.nextSibling); }
      else { lineEl.appendChild(note); }
    }
    note.hidden = false;
    var msg = window.TdhqQty.reason(key.split(':')[0], 'line');
    if (note.textContent !== msg) { note.textContent = msg; }
  }

  function queueLine(key, quantity, lineEl) {
    cdTargets[key] = quantity;
    /* Optimistic: the number the shopper asked for appears in the same frame.
       Waiting for the round trip before moving the digit is what reads as a
       dead control.

       EXCEPT A REMOVAL. Writing 0 took the line off its stock ceiling, so
       paintLineCap hid the "Only 1 in stock." note at once: the list dropped
       32px in the first frame after the tap, 3ms in, and only then did the
       line start to close (measured at 390 and 1440). The stepper also read
       0 for the whole close, which the basket page never shows. A line on
       its way out keeps its digit and its note, dims like any busy line, and
       closes as one piece. */
    if (quantity > 0) {
      var valEl = lineEl && lineEl.querySelector('[data-cd-qtyval]');
      if (valEl) { valEl.textContent = quantity; }
      paintLineCap(lineEl);
    } else if (lineEl) {
      lineEl.classList.add('is-busy');
      lineEl.setAttribute('aria-busy', 'true');
    }
    if (cdBusy) { return; }
    drainLine();
  }

  function drainLine() {
    for (var k in cdTargets) {
      if (!Object.prototype.hasOwnProperty.call(cdTargets, k)) { continue; }
      var q = cdTargets[k];
      var el = root.querySelector('[data-cd-item][data-key="' + esc(k) + '"]');
      cdBusy = true;
      changeLine(k, q, el);
      return true;
    }
    cdBusy = false;
    return false;
  }

  function settleLine(key, sent) {
    /* Only clear the target this request actually satisfied: a newer tap that
       arrived mid-flight has to survive and be sent. */
    if (cdTargets[key] === sent) { delete cdTargets[key]; }
    cdBusy = false;
    window.setTimeout(drainLine, 0);
  }

  function changeLine(key, quantity, lineEl) {
    if (lineEl) { lineEl.classList.add('is-busy'); lineEl.setAttribute('aria-busy', 'true'); }
    /* Read the title BEFORE the request: render() destroys the line node, and
       a removal has no line left to name afterwards. */
    var titleEl = lineEl && lineEl.querySelector('.tdhq-cd__name');
    var title = (titleEl && titleEl.textContent.trim()) || 'Item';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        /* `r.ok ? r.json() : null` swallowed every failure: the line kept its
           busy dim for ever, no message appeared, and the basket had already
           changed underneath. A rejected request now says why. */
        if (!r.ok) {
          return r.json()
            .catch(function () { throw new Error('Could not update your basket. Please try again.'); })
            .then(function (e) {
              var err = new Error(e.description || e.message || 'Could not update your basket.');
              /* 400 "no valid id or line parameter": this line is no longer in the basket (changed in another tab or
                 on another device). Not the shopper's error to read - the basket is simply redrawn as it is. */
              err.stale = r.status === 400 && /no valid id|line parameter/i.test(err.message);
              throw err;
            });
        }
        return r.json();
      })
      .then(function (cart) {
        /* the removed line's product may have been the recommendation seed;
           a quantity change leaves the seed, and the rail, as they are */
        if (quantity === 0) { recsLoadedFor = null; }
        function finish() {
          settleLine(key, quantity);
          render(cart);
          publishCartChange(cart);
          announce(
            (quantity === 0
              ? title + ' removed from your basket. '
              : title + ', quantity ' + quantity + '. ') +
            (cart.item_count === 0
              ? 'Your basket is now empty.'
              : cart.item_count + (cart.item_count === 1 ? ' item' : ' items') +
                ' in your basket, total ' + money(payable(cart)) + '.')
          );
        }
        /* A REMOVED LINE CLOSES (audit cart-10), the way it does on the basket
           page, instead of vanishing and snapping the list up. Its measured
           height is the starting point and 0px the end. The queue is settled
           and the new basket drawn together, when the line has gone, so a tap
           queued meanwhile can never be answered by an older basket. */
        var line = lineEl && lineEl.isConnected ? lineEl : null;
        if (quantity === 0 && line && window.TdhqMotion) {
          window.TdhqMotion.exit(line, finish);
        } else {
          finish();
        }
      })
      .catch(function (err) {
        if (lineEl) { lineEl.classList.remove('is-busy'); lineEl.removeAttribute('aria-busy'); }
        /* RE-SYNC FIRST, THEN SPEAK. render() empties the list and rebuilds
           every line, so a message written before this ran was destroyed a
           frame later - the shopper saw the digit twitch back with no
           explanation at all. The line that comes back is a different element,
           so it is found again by key. */
        var msg = err && !err.stale ? err.message : null;
        /* A refused line clears its own target - the server has told us what it
           will accept - but the other lines the shopper touched are not this
           line's fault and still go. */
        delete cdTargets[key];
        cdBusy = false;
        window.setTimeout(drainLine, 0);
        return refresh().then(function (cart) {
          /* The basket could not be read either: refresh() hands back null and
             nothing redrew, so the digit the shopper asked for stayed on screen
             although the basket never changed. Redraw the last basket the
             server confirmed (this line's target is already cleared). */
          if (!cart && lastCart) { render(lastCart); }
          publishCartChange(cart);
          var fresh = root.querySelector('[data-cd-item][data-key="' + esc(key) + '"]');
          showLineError(fresh, msg);
          if (msg) { announce(msg); }
        });
      });
  }

  /* ---------------------------------------------------------------
     Events
     --------------------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-cd-close]');
    if (closer) { e.preventDefault(); close(); return; }

    var line = e.target.closest('[data-cd-item]');
    if (!line) { return; }
    var key = line.getAttribute('data-key');

    var step = e.target.closest('[data-cd-step]');
    if (step) {
      /* Read the TARGET, not the DOM. The digit is now moved optimistically, so
         the DOM is already the right base - but a pending target is righter
         still when a burst of taps is in progress. */
      var valEl = line.querySelector('[data-cd-qtyval]');
      var current = (cdTargets[key] !== undefined)
        ? cdTargets[key]
        : (parseInt(valEl && valEl.textContent, 10) || 0);
      var next = current + parseInt(step.getAttribute('data-cd-step'), 10);
      if (next < 0) { next = 0; }
      /* THE STOCK CEILING. The line key's first segment is the variant id, and
         the shared store holds what Liquid rendered for it. Refusing here is
         what the client asked for: the shopper is told at the control, not at
         the checkout.

         AND THERE IS NOTHING BEHIND THIS. Measured 2026-09-23 on five
         products: /cart/add.js accepted 21 units of a variant with 1 in
         stock, and every other oversell tried, all HTTP 200. Shopify is not
         refusing anything on this shop, so this clamp is the only guard,
         not a nicety in front of a server-side one. */
      if (window.TdhqQty && next > current) {
        var cap = window.TdhqQty.stock(key.split(':')[0]);
        if (cap !== null && next > cap) {
          showLineError(line, window.TdhqQty.reason(key.split(':')[0], 'line'));
          return;
        }
      }
      showLineError(line, '');
      queueLine(key, next, line);
      return;
    }

    if (e.target.closest('[data-cd-remove]')) {
      queueLine(key, 0, line);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) { return; }
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || !panel) { return; }

    /* Focus trap. A modal that lets Tab wander onto the page behind it is a
       keyboard dead end: the shopper cannot see where focus went. */
    var focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    /* The empty-state block and the footer are hidden with `hidden` when the
       basket has items (and the reverse when it does not), but their buttons
       still match the focusable selector - so `first` or `last` could be an
       element nobody can see, and Tab escaped the drawer. Only visible controls
       count. */
    var visible = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!visible.length) { return; }
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* The header basket link becomes the drawer trigger, but stays a real <a> to
     /cart so it still works with JS off, opens in a new tab on middle-click, and
     is announced as a link to the basket. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-tdhq-cart-link]');
    if (!link) { return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) { return; }
    e.preventDefault();
    open();
    refresh();
  });

  /* Fired by tdhq-quickadd.js and by the PDP buy form once an add is confirmed. */
  document.addEventListener('tdhq:cart:added', function (e) {
    recsLoadedFor = null;
    lastAddedProductId = (e && e.detail && e.detail.productId) || null;
    /* The drawer opens on whatever it last rendered, and the refresh lands a
       moment later - so the FIRST add on an empty basket flashed "Your basket is
       empty" as its confirmation. Suppress the empty state for the length of the
       in-flight refresh: something has just been added, so empty is known to be
       wrong even before the new cart arrives. */
    if (emptyEl) { emptyEl.hidden = true; }
    if (itemsEl) { itemsEl.hidden = false; }
    root.classList.add('is-loading');
    /* On the basket page the basket is already on screen (owner 21 Oct): the drawer stays shut and the page itself
       takes the new line (sections/dtc-cart redraws on tdhq:cart:changed, which showAdded publishes). */
    if (!document.querySelector('[data-dtc-cart]')) { open(); }
    var added = e && e.detail && e.detail.item;
    showAdded(added).then(function () { root.classList.remove('is-loading'); }, function () { root.classList.remove('is-loading'); });
  });

  /* Nothing is asked for until the basket is wanted (audit cart-16). The
     lines are drawn by the server with the page; the drawer refreshes - its
     recommendations, and any change made in another tab - as the shopper
     reaches for the basket link, so it is ready when it opens, and again on
     open. The delivery meter is the one part the server leaves empty, so a
     basket with the meter switched on is still filled in at once. */
  var warmed = false;
  function warm(e) {
    if (warmed || !e.target || !e.target.closest || !e.target.closest('[data-tdhq-cart-link]')) { return; }
    warmed = true;
    if (root.querySelector('[data-cd-item]')) { refresh(); }
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  if (shipEl && root.querySelector('[data-cd-item]')) { refresh(); }

  window.tdhqCartDrawer = { open: open, close: close, refresh: refresh };
})();
